export interface PatentProfileRequest {
    pns: string[];
}

export type PatentProfileResponse = {
    SOLUTION_ID: string;
    PN: string;
    TITLE: string;
    ABST: string;
    ORG_INFO?: {
        normalized_name: string;
        logo: string;
        entity_type: 'Company' | 'Person';
    }[];
}[]

/**
 * 专利概要信息 API
 */
export interface PatentProfileApi {
    /**
     * 获取专利概要信息
     * @param data
     * @returns
     */
    getPatentProfile: (data: PatentProfileRequest) => Promise<PatentProfileResponse>;
}

export const PatentProfileApi = Symbol('PatentProfileApi');
